import { CSS_MQ } from "./breakpoints";
import { css } from "@emotion/react";
import { richTextAnchorStyles, richTextBlockQuoteStyle, richTextBoldStyles, richTextListStyles } from "./rich-text";
import { capitalizationClassName } from "../domain/swarovski-optik/products/product-name/label-contains-product-name";

export const plainTextSmStyles = css`
  font-size: 16px;
  // letter-spacing: 1px;
  line-height: 21px;
`;

export const plainTextSmPlusStyles = css`
  font-size: 18px;
  // letter-spacing: 0.86px;
  line-height: 21px;
`;

export const plainTextMdStyles = css`
  font-size: 21px;
  // letter-spacing: 1.05px;
  line-height: 26px;
`;

export const responsivePlainTextStyles = css`
  ${plainTextSmStyles};

  ${CSS_MQ.atLeastSm} {
    ${plainTextSmPlusStyles};
  }

  ${CSS_MQ.atLeastMd} {
    ${plainTextMdStyles};
  }
`;

export const plainTextStyles = [
  responsivePlainTextStyles,
  richTextAnchorStyles,
  richTextBoldStyles,
  richTextListStyles,
  richTextBlockQuoteStyle, // out of designs
];

export const capitalizeIfNoProductNameStyles = css`
  &:not(.${capitalizationClassName}) {
    text-transform: uppercase;
  }
`;
